import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)
var storeData=JSON.parse(localStorage.getItem('state'));
var axiosUrl=process.env.VUE_APP_API_URL
if(storeData==null||axiosUrl!=storeData.axiosUrl)
{
    storeData={ 
        title:'经济学院',
        login:{},
        user:{},
        axiosUrl:axiosUrl
    };
    localStorage.setItem("access_token", '');
}
var token=localStorage.getItem('access_token')?localStorage.getItem('access_token'):'';
var timeStart=localStorage.getItem('tokenTime')?localStorage.getItem('tokenTime'):0;
var date=new Date();
var timeEnd=date.getTime();
var tokenTerm=localStorage.getItem('tokenTime')?localStorage.getItem('tokenTime'):0;
if(timeEnd-timeStart>tokenTerm)
{
    token='';
}
storeData.access_token=token
//创建VueX对象
const store = new Vuex.Store({
    //存放的键值对就是所要管理的状态
    state:storeData,
    mutations:{
        //es6语法，等同edit:funcion(){...}
        // 设置参数
        set(state,obj){
            state[obj.name] = obj.val;
            localStorage.setItem("state", JSON.stringify(state));
        },
    },
})

export default store

// console.log(this.$store.state.info);
// this.$store.commit('set',{name：'变量名',val:值});
// console.log(this.$store.state.info);
